import { render, staticRenderFns } from "./comboGeneral.vue?vue&type=template&id=0a1e792c"
import script from "./comboGeneral.vue?vue&type=script&lang=js"
export * from "./comboGeneral.vue?vue&type=script&lang=js"
import style0 from "./comboGeneral.vue?vue&type=style&index=0&id=0a1e792c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports